export const getShopId = () => {
  return localStorage.getItem("shopId");
};